module.exports = "<div>\n  <div *ngIf=\"visible\" class=\"autocomplete-items\" style=\"width:300px;\">\n    <div *ngFor=\"let suggestion of suggestions\" (click)=\"setInvisible(suggestion)\"> {{suggestion}} </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/template/password-viewer/password-fields/autocomplete/autocomplete.component.html
// module id = ./src/app/template/password-viewer/password-fields/autocomplete/autocomplete.component.html
// module chunks = main